<template>
  <div style="zoom: 0.8" class="manual_bill_wrapper">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Generate Manual Bill</div>
    </div>
    <div class="white-wrapper" v-if="!billGenerated">
      <div class="row">
        <div class="col-6">
          <div class="row align-items-center mb-2">
            <div class="col-3">
              <span class="font-weight-bold">Cinema Name</span>
            </div>
            <div class="col-9">
              <div class="dropdown-curve-container">
                <multiselect
                  :options="Cinemas"
                  v-model="selectedCinema"
                  :searchable="true"
                  label="cine_name"
                  track-by="cine_name"
                  placeholder="Select Cinema"
                  :preselect-first="true"
                  @select="onSelectCinema(null, $event)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row align-items-center mb-2">
            <div class="col-3">
              <span class="font-weight-bold">Client Name</span>
            </div>
            <div class="col-9">
              <div class="dropdown-curve-container">
                <multiselect
                  :options="Clients"
                  v-model="selectedClient"
                  :searchable="true"
                  label="client_name"
                  track-by="client_id"
                  placeholder="Select Client"
                  :preselect-first="true"
                  @select="onSelectClient(null, $event)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row align-items-center mb-2">
            <div class="col-3">
              <span class="font-weight-bold">Client Address</span>
            </div>
            <div class="col-9">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="bill['client_address']"
                    type="text"
                    name="client_address"
                    id="client_address"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row align-items-center mb-2">
            <div class="col-3">
              <span class="font-weight-bold">Bill Date</span>
            </div>
            <div class="col-9">
              <div class="input-material">
                <div class="add-datepicker">
                  <Datepicker
                    :disabled="true"
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="bill.bill_date"
                    name="bill_date"
                    id="bill_date"
                    :typeable="true"
                  ></Datepicker>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6" v-if="!isEmpire">
          <div class="row align-items-center mb-2">
            <div class="col-3">
              <span class="font-weight-bold">Client PAN</span>
            </div>
            <div class="col-9">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="bill['client_pan']"
                    type="text"
                    name="client_pan"
                    id="client_pan"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6" v-if="isEmpire">
          <div class="row align-items-center mb-2">
            <div class="col-3">
              <span class="font-weight-bold">Client CR</span>
            </div>
            <div class="col-9">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    disabled
                    placeholder="."
                    v-model="bill['client_cr_no']"
                    type="text"
                    name="client_cr_no"
                    id="client_cr_no"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6" v-if="isEmpire">
          <div class="row align-items-center mb-2">
            <div class="col-3">
              <span class="font-weight-bold">Client VAT</span>
            </div>
            <div class="col-9">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    disabled
                    placeholder="."
                    v-model="bill['client_vat_no']"
                    type="text"
                    name="client_vat_no"
                    id="client_vat_no"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <b-collapse
          v-model="collapseObj.item_array"
          class="pt-3 px-2 bor mb-4 back collapse show w-100"
        >
          <section class="row">
            <div class="w-100 mx-3 mb-3">
              <table
                class="swc-report-table"
                border="1"
                style="table-layout: auto; background: white"
              >
                <thead>
                  <tr>
                    <th class="bg-lightgrey p-1" style="width: 240px">Item</th>
                    <th class="bg-lightgrey p-1" style="width: 240px">HS Code</th>
                    <th class="bg-lightgrey p-1" style="width: 240px">
                      Description
                    </th>
                    <th class="bg-lightgrey p-1" style="width: 100px">QTY</th>
                    <th class="bg-lightgrey p-1" style="width: 100px">Unit</th>
                    <th class="bg-lightgrey p-1" style="width: 240px">
                      Tax Setting
                    </th>
                    <th class="bg-lightgrey p-1" style="width: 125px">
                      Gross Rate
                    </th>
                    <th class="bg-lightgrey p-1" style="width: 125px">
                      Net Rate
                    </th>
                    <th class="bg-lightgrey p-1" style="width: 140px">
                      Net Sum
                    </th>
                    <th class="bg-lightgrey p-1" style="width: 125px">Tax</th>
                    <th class="bg-lightgrey p-1" style="width: 140px">
                      Gross Sum
                    </th>
                    <th class="bg-lightgrey p-1" style="width: 80px">Action</th>
                  </tr>
                </thead>
                <tbody v-if="bill['items_array'].length > 0">
                  <tr
                    v-for="(list, listKey) in bill['items_array']"
                    :key="listKey"
                    :class="errIndex == listKey ? 'errRow' : ''"
                  >
                    <td class="text-left p-0 manual_bill_item">
                      <multiselect
                        :options="Items"
                        v-model="list.selectedItem"
                        :searchable="true"
                        label="item_name"
                        track-by="item_id"
                        placeholder="Select Item"
                        @select="onSelectBillItem($event, listKey)"
                      />
                    </td>
                    <td class="text-left p-0">
                      <div class="manual_bill_input">
                        <input
                          placeholder="Enter HS Code"
                          v-model="list.hs_code"
                          type="text"
                          :name="`hs_code_${listKey}`"
                          :id="`hs_code_${listKey}`"
                        />
                      </div>
                    </td>
                    <td class="text-left p-0">
                      <div class="manual_bill_input">
                        <input
                          placeholder="Enter Description"
                          v-model="list.description"
                          type="text"
                          :name="`description_${listKey}`"
                          :id="`description_${listKey}`"
                        />
                      </div>
                    </td>
                    <td class="text-right p-0">
                      <div class="manual_bill_input input_text-center">
                        <input
                          placeholder="Qty."
                          v-model="list.item_qty"
                          type="number"
                          :name="`item_qty_${listKey}`"
                          :id="`item_qty_${listKey}`"
                          @change="cinemaChargesCalculation(listKey)"
                        />
                      </div>
                    </td>
                    <td class="text-left p-0 manual_bill_item">
                      <multiselect
                        :options="UomList"
                        v-model="list.selectedUOM"
                        :searchable="true"
                        label="uom_short_form"
                        track-by="uom_id"
                        placeholder="UOM"
                        :showLabels="false"
                        @select="onSelectUOM($event, listKey)"
                        @remove="onRemoveUOM($event, listKey)"
                      />
                    </td>
                    <td class="text-right p-0 manual_bill_item">
                      <multiselect
                        :options="ChargeSettings"
                        v-model="list.selectedChargeSetting"
                        :searchable="true"
                        label="pas_charge_setting_name"
                        track-by="pas_id"
                        placeholder="Select Tax Setting"
                        @select="onSelectBillTaxSetting($event, listKey)"
                      />
                    </td>
                    <td class="text-right p-0">
                      <div class="manual_bill_input input_text-right">
                        <input
                          placeholder="Rate."
                          v-model="list.unit_gross"
                          type="number"
                          :name="`unit_gross_${listKey}`"
                          :id="`unit_gross_${listKey}`"
                          @change="cinemaChargesCalculation(listKey)"
                        />
                      </div>
                    </td>
                    <td class="text-right">{{ currFormat(list.unit_net) }}</td>
                    <td class="text-right">{{ currFormat(list.net_amount) }}</td>
                    <td class="text-right" :id="`popover-tax-${listKey}`">
                      {{ currFormat(list.tax_amount) }}
                      <b-popover
                        :target="`popover-tax-${listKey}`"
                        triggers="hover focus"
                        placement="bottom"
                        custom-class="taxPopOver"
                      >
                        <template #title></template>
                        <div
                          v-for="(tax, taxIndex) in list.taxes"
                          :key="taxIndex"
                          class="row"
                        >
                          <div class="col-6 font-weight-bold">
                            {{ tax.ct_code || tax.charge_name }}
                          </div>
                          <div class="col-6">{{ tax.cinemacharges || 0 }}</div>
                        </div>
                      </b-popover>
                    </td>
                    <td class="text-right">{{ currFormat(list.gross_amount) }}</td>
                    <td>
                      <div
                        class="icon-sm-minus blue-icon ml-2 btn"
                        @click="onRemoveItemFromBill(list, listKey)"
                      ></div>
                    </td>
                  </tr>
                  <tr class="">
                    <td colspan="12">
                      <div
                        class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                      >
                        <button
                          @click="onAddItemToBill()"
                          class="btn-transparent add-more-button addBtn_multi"
                        >
                          <img
                            src="@/assets/img/icons/plus.svg"
                            height="24"
                            width="24"
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="bill['items_array'].length > 0">
                  <tr>
                    <td colspan="8" class="borderNone"></td>
                    <td colspan="2" class="font-weight-bold text-left">
                      Net Total
                    </td>
                    <td colspan="2" class="font-weight-bold text-right">
                      {{
                        currFormat(
                          bill["items_array"].reduce(
                            (acc, { net_amount }) =>
                              acc + parseFloat(net_amount || 0),
                            0
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="8" class="borderNone"></td>
                    <td colspan="2" class="font-weight-bold text-left">
                      Tax Total
                    </td>
                    <td colspan="2" class="font-weight-bold text-right">
                      {{
                        currFormat(
                          bill["items_array"].reduce(
                            (acc, { tax_amount }) =>
                              acc + parseFloat(tax_amount || 0),
                            0
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="8" class="borderNone"></td>
                    <td colspan="2" class="font-weight-bold text-left">
                      Gross Total
                    </td>
                    <td colspan="2" class="font-weight-bold text-right">
                      {{
                        currFormat(
                          bill["items_array"].reduce(
                            (acc, { gross_amount }) =>
                              acc + parseFloat(gross_amount || 0),
                            0
                          )
                        )
                      }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="">
                    <td colspan="12"></td>
                  </tr>
                  <tr class="">
                    <td colspan="12">
                      <div
                        class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                      >
                        <button
                          @click="onAddItemToBill()"
                          class="btn-transparent add-more-button addBtn_multi"
                        >
                          <img
                            src="@/assets/img/icons/plus.svg"
                            height="24"
                            width="24"
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </b-collapse>
      </div>

      <section>
        <div class="row">
          <div class="mx-auto">
            <button
              :disabled="btenable"
              @click.prevent.stop="onGenerateBill()"
              class="btn-blue"
            >
              {{ "Generate Bill" }}
            </button>
            <b-button
              @click.prevent.stop="resetHandler()"
              class="btn btn-black btn-default"
              variant="default"
              >{{ "Reset" }}</b-button
            >
            <b-button
              @click.prevent.stop="onCancel()"
              class="btn-outline-grey"
              variant="default"
              >{{ $t("cancel") }}</b-button
            >
          </div>
        </div>
      </section>
    </div>
    <div class="white-wrapper" v-else>
      <div class="row">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="success-tick-wrapper">
            <span class="complete-tick">
              <img
                src="@/assets/img/icons/success-tick.svg"
                height="110"
                width="110"
                class="mr-2"
              />
            </span>
            <div class="refund-text font-weight-bold mb-3">Bill Generated.</div>
            <table
              class="swc-report-table mb-4"
              border="1"
              style="table-layout: auto; background: white"
            >
              <tbody v-if="bill['items_array'].length > 0">
                <tr>
                  <td class="font-weight-bold text-left">Net Total</td>
                  <td class="font-weight-bold text-right">
                    {{
                      currFormat(
                        bill["items_array"].reduce(
                          (acc, { net_amount }) =>
                            acc + parseFloat(net_amount || 0),
                          0
                        )
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold text-left">Tax Total</td>
                  <td class="font-weight-bold text-right">
                    {{
                      currFormat(
                        bill["items_array"].reduce(
                          (acc, { tax_amount }) =>
                            acc + parseFloat(tax_amount || 0),
                          0
                        )
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold text-left">Gross Total</td>
                  <td class="font-weight-bold text-right">
                    {{
                      currFormat(
                        bill["items_array"].reduce(
                          (acc, { gross_amount }) =>
                            acc + parseFloat(gross_amount || 0),
                          0
                        )
                      )
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <button v-on:click="resetHandler()" class="btn-blue-lg">
            {{ $t("close") }}
          </button>
          <button v-on:click="onPrintHandler()" class="btn-blue-lg">
            {{ $t("Print") }}
          </button>
        </div>
      </div>
    </div>
    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import NoRecords from "@/components/Partials/NoRecords.vue";
import Printd from "printd";
import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

export default {
  components: { NoRecords },
  data() {
    return {
      billId: null,
      billGenerated: false,
      EjsData: null,
      errIndex: null,
      Cinemas: [],
      Clients: [],
      Items: [],
      UomList: [],
      ChargeSettings: [],
      btenable: false,
      selectedCinema: "",
      selectedClient: "",
      cinema_id: null,
      submitted: false,
      collapseObj: {
        item_array: true,
      },
      bill: {
        cinema_id: null,
        cinema_name: "",
        client_id: null,
        client_name: null,
        client_pan: null,
        client_cr_no: null,
        client_vat_no: null,
        client_address: null,
        bill_date: new Date(),
        items_array: [],
      },
      itemObj: {
        item_id: null,
        item_name: "",
        alt_item_name: "",
        selectedItem: "",
        selectedUOM: "",
        uom_id: null,
        uom_name: "",
        charge_setting_id: null,
        charge_setting_name: null,
        selectedChargeSetting: "",
        category_id: null,
        category_name: null,
        description: "",
        hs_code: null,
        item_qty: null,
        unit_net: 0,
        unit_gross: 0,
        net_amount: 0,
        tax_amount: 0,
        gross_amount: 0,
        taxes: [],
        charge_array: [],
      },
    };
  },
  mounted() {},
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.getCinemaList(obj);
    this.getClientsList();
    this.getAllItemList();
    this.getUomList();
  },
  computed: {
    isEmpire() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.empire) || false;
    },
  },
  methods: {
    validateBill(showToast = true) {
      let errCount = 0;
      let errMsg = ``;

      if (!this.bill.cinema_id) {
        errCount++;
        this.errIndex = null;
        errMsg = `Please Select Cinema.`;
      } else if (!this.bill.client_id) {
        errCount++;
        this.errIndex = null;
        errMsg = `Please Select Client.`;
      } else if (!this.bill.bill_date) {
        errCount++;
        this.errIndex = null;
        errMsg = `Please Select Bill Date.`;
      } else if (!this.bill.items_array || this.bill.items_array.length == 0) {
        errCount++;
        this.errIndex = null;
        errMsg = `Please Select Items.`;
      } else if (this.bill.items_array.length > 0) {
        this.bill.items_array.forEach((item, itemIndex) => {
          if (errCount > 0) {
            return;
          } else {
            if (!item.item_id) {
              errCount++;
              this.errIndex = itemIndex;
              errMsg = `Item Field Required.`;
            } else if (!item.item_qty) {
              errCount++;
              this.errIndex = itemIndex;
              errMsg = `Please Enter Valid Quantity.`;
            } else if (!item.charge_setting_id) {
              errCount++;
              this.errIndex = itemIndex;
              errMsg = `Please Select Tax Setting.`;
            } else if (!item.unit_gross) {
              errCount++;
              this.errIndex = itemIndex;
              errMsg = `Please Enter Gross Amount.`;
            } else if (!item.uom_id) {
              errCount++;
              this.errIndex = itemIndex;
              errMsg = `Please Select Unit.`;
            }
          }
        });
      }

      if (errCount > 0) {
        if (showToast) {
          this.$toasted.show(errMsg);
        }
        return false;
      } else {
        return true;
      }
    },
    onCancel() {
      this.$router.replace({
        path: "/cinema-manager/bill-transactions",
      });
    },
    resetHandler() {
      this.billId = null;
      this.billGenerated = false;
      this.EjsData = null;
      this.errIndex = null;
      this.selectedCinema = "";
      this.selectedClient = "";
      this.cinema_id = null;
      this.submitted = false;
      this.bill = {
        cinema_id: null,
        cinema_name: "",
        client_id: null,
        client_name: null,
        client_pan: null,
        client_cr_no: null,
        client_vat_no: null,
        client_address: null,
        bill_date: new Date(),
        items_array: [],
      };
      this.$forceUpdate();
    },
    onPrintHandler() {
      let payload = {
        isPrint: "Y",
        bill_id: this.billId,
      };
      let loader = this.$loading.show();
      CinemasService.GetManualBillDetails(payload)
        .then((response) => {
          if (response) {
            const { data } = response;
            if (data && data.hasOwnProperty("status") && !data.status) {
              this.$toasted.show(data.message || "Print Failed!");
            } else {
              this.EjsData = data;
              this.$nextTick(() => {
                const p = new Printd();
                if (this.$refs.onPrint && this.EjsData != null) {
                  p.print(this.$refs.onPrint, []);
                }
              });
            }
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    onGenerateBill() {
      if (this.validateBill()) {
        let payload = {
          bill: this.bill,
        };
        let loader = this.$loading.show();
        CinemasService.GenerateManualBill(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.$toasted.show(data.message);
              this.billId = data.bill_id;
              this.billGenerated = true;
              this.onPrintHandler();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    getFloat(val = "0", fractionDigits = 8) {
      let parsed = parseFloat(String(val) || "0") || parseFloat("0");
      return parseFloat(parsed.toFixed(fractionDigits));
    },
    onSelectBillItem(item, listIndex) {
      this.bill.items_array[listIndex].item_name = item.item_name;
      this.bill.items_array[listIndex].alt_item_name = item.alt_item_name;
      this.bill.items_array[listIndex].item_id = item.item_id;
      this.bill.items_array[listIndex].category_id = item.category_id;
      this.bill.items_array[listIndex].category_name = item.category_name;
    },
    onSelectUOM(UOM, listIndex) {
      this.bill.items_array[listIndex].uom_name = UOM.uom_short_form;
      this.bill.items_array[listIndex].uom_id = UOM.uom_id;
    },
    onRemoveUOM(UOM, listIndex) {
      this.bill.items_array[listIndex].uom_name = "";
      this.bill.items_array[listIndex].uom_id = null;
    },
    onSelectBillTaxSetting(taxSetting, listIndex) {
      this.bill.items_array[listIndex].charge_setting_name =
        taxSetting.pas_charge_setting_name;
      this.bill.items_array[listIndex].charge_setting_id = taxSetting.pas_id;
      this.getCinemaCharges(taxSetting, listIndex);
    },
    onRemoveItemFromBill(item, itemIndex) {
      this.bill.items_array.splice(itemIndex, 1);
    },
    onAddItemToBill() {
      let itemObj = {
        item_id: null,
        item_name: "",
        alt_item_name: "",
        selectedItem: "",
        selectedUOM: "",
        uom_id: null,
        uom_name: "",
        charge_setting_id: null,
        charge_setting_name: null,
        selectedChargeSetting: "",
        category_id: null,
        category_name: null,
        description: "",
        hs_code: null,
        item_qty: null,
        unit_net: 0,
        unit_gross: null,
        net_amount: 0,
        tax_amount: 0,
        gross_amount: 0,
        taxes: [],
        charge_array: [],
      };
      this.bill.items_array.push(itemObj);
    },
    getUomList() {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.UomList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectCinema(event, cinema) {
      this.selectedCinema = cinema;
      this.cinema_id = cinema.cine_id;
      this.bill["cinema_id"] = cinema.cine_id;
      this.bill["cinema_name"] = cinema.cine_name;
      this.getChargeSettingName(cinema.cine_id);
    },
    onSelectClient(event, client) {
      this.selectedClient = client;
      this.bill["client_id"] = client.client_id;
      this.bill["client_name"] = client.client_name;
      this.bill["client_pan"] = client.client_pan_no;
      this.bill["client_cr_no"] = client.client_cr_no;
      this.bill["client_vat_no"] = client.client_vat_no;
      this.bill["client_address"] = client.client_address;
    },
    getCinemaList: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onSelectCinema(null, {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                });
              }
            });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    getAllItemList() {
      let loader = this.$loading.show();
      MasterService.GetAllManualBiilingItems()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.Items = data.Records;
          } else {
            this.$toasted.show("No Items Found!");
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getClientsList() {
      let payload = {
        tableName: "ms_clients",
        client_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Clients = data.Records;
          } else {
            console.log("show error :", data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    getChargeSettingName: function (cinema_id) {
      this.ChargeSettings = [];
      CinemasService.GetChargeSettingsWithChargeTypes({ cinema_id: cinema_id })
        .then(async (response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ChargeSettings = data.Records;
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Error :", error);
        });
    },
    getCinemaCharges: function (charge_setting, index = 0) {
      this.bill.items_array[index].charge_array = [];
      this.bill.items_array[index].taxes = [];

      let cinemaChargesArray = charge_setting["charge_array"] || [];
      this.bill.items_array[index].charge_array =
        charge_setting["charge_array"] || [];

      cinemaChargesArray.map((x) => {
        let obj = {
          pas_order: x.pas_order || 0,
          charge_name: x.ct_name,
          cinemacharges: 0,
          charge_value: x.pas_charge_value,
          ct_id: x.ct_id,
          ct_code: x.ct_code,
          pas_id: x.pas_id,
          pas_is_percentage: x.pas_is_percentage,
        };
        this.bill.items_array[index].taxes.push(obj);
      });

      this.cinemaChargesCalculation(index);
    },
    cinemaChargesCalculation: function (listIndex) {
      let tempChargeArray = this.bill.items_array[listIndex].charge_array;
      if (true) {
        let grosss = this.getSafe(() => tempChargeArray.map((x) => x), [])
          .filter((z) => z.pas_is_on_gross_amount == "Y")
          .filter((g) => String(g.ct_name).toUpperCase().includes("VAT"))
          .filter((g) => g.pas_is_percentage === "Y");

        let nets = this.getSafe(() => tempChargeArray.map((x) => x), [])
          .filter((z) => z.pas_is_on_gross_amount == "N")
          .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"))
          .filter((g) => g.pas_is_percentage === "Y");

        let misc_products = this.getSafe(
          () => tempChargeArray.map((x) => x),
          []
        )
          .filter((g) => g.pas_is_percentage === "N")
          .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"));

        console.log({
          nets,
          grosss,
          misc_products,
          taxes: tempChargeArray.map((x) => x),
        });

        let vat_pas_id = this.getSafe(() => grosss[0].pas_id);
        let vat_percent = this.getFloat(
          this.getSafe(() => grosss[0].pas_charge_value, 0)
        );

        let net_1_pas_id = this.getSafe(() => nets[0].pas_id);
        let net_1_percent = this.getFloat(
          this.getSafe(() => nets[0].pas_charge_value, "0")
        );

        let net_2_pas_id = this.getSafe(() => nets[1].pas_id);
        let net_2_percent = this.getFloat(
          this.getSafe(() => nets[1].pas_charge_value, "0")
        );

        let misc_product_rate_pas_id = this.getSafe(
          () => misc_products[0].pas_id
        );
        let misc_product_rate_1 = this.getFloat(
          this.getSafe(() => misc_products[0].pas_charge_value, "0")
        );
        let misc_rate_exist =
          misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0;
        let amount = this.getFloat(
          this.bill.items_array[listIndex].unit_gross || 0
        );

        /** Gross */
        let G = amount;
        /** Taxable/Net */
        let E = this.getFloat(amount / (1 + vat_percent / 100));
        /** VAT */
        let F = this.getFloat((vat_percent / 100) * E);
        /** 3D/Prod */
        let B = this.getFloat(misc_product_rate_1 / (1 + vat_percent / 100));
        /** Ticket Rate */
        let totalPerCentOfA = 1 + (net_1_percent + net_2_percent) / 100;
        let A = this.getFloat((E - B) / totalPerCentOfA);
        /** Film Dev Tax */
        let C = this.getFloat((net_1_percent / 100) * A);
        /** State & Local Ent Tax */
        let D = this.getFloat((net_2_percent / 100) * A);

        console.log({
          amount,
          vat_percent,
          net_1_percent,
          net_2_percent,
          totalPerCentOfA,
          misc_rate_exist,
          misc_product_rate_1,
        });
        console.log({
          Gross: G,
          Net: E,
          VAT: F,
          FDT: C,
          SLE: D,
          "3D": B,
          TicketRate: A,
          ProductRate: B,
        });

        let NET_AMT = E;
        let BASE_RATE = A;
        let NET_1_AMT = C;
        let NET_2_AMT = D;
        let NET_3_AMT = B; // misc_product_rate_1
        let VAT_AMT = F;
        let Gross = G;

        this.bill.items_array[listIndex].unit_net = parseFloat(
          BASE_RATE + NET_3_AMT
        );

        tempChargeArray.map((x, i) => {
          let index = this.bill.items_array[listIndex]["taxes"].findIndex(
            (zz) => zz.ct_id == x.charge_type_id
          );

          if (x.pas_id == net_1_pas_id) {
            x.cinemacharges = NET_1_AMT;
          }
          if (x.pas_id == net_2_pas_id) {
            x.cinemacharges = NET_2_AMT;
          }
          if (x.pas_id == misc_product_rate_pas_id) {
            x.cinemacharges = NET_3_AMT;
          }

          if (x.pas_id == vat_pas_id) {
            x.cinemacharges = VAT_AMT;
          }

          this.bill.items_array[listIndex].taxes[index].cinemacharges =
            x.cinemacharges || 0;
        });

        let unitNet = parseFloat(this.bill.items_array[listIndex].unit_net);

        let unitGross = parseFloat(
          this.bill.items_array[listIndex].unit_gross || 0
        );

        let qty = this.getFloat(this.bill.items_array[listIndex].item_qty);

        this.bill.items_array[listIndex].unit_net = parseFloat(
          parseFloat(unitNet || 0)
        ).toFixed(4);

        this.bill.items_array[listIndex].net_amount = parseFloat(
          parseFloat(unitNet || 0) * parseInt(qty || 0)
        ).toFixed(this.MIN_FRACTION_DIGITS);

        this.bill.items_array[listIndex].gross_amount = parseFloat(
          unitGross * qty
        ).toFixed(this.MIN_FRACTION_DIGITS);

        this.bill.items_array[listIndex].taxes.forEach((tax) => {
          tax["cinemacharges"] = +parseFloat(
            parseFloat(tax["cinemacharges"]) * parseInt(qty)
          ).toFixed(this.MIN_FRACTION_DIGITS);
        });

        this.bill.items_array[listIndex].tax_amount = parseFloat(
          this.bill.items_array[listIndex].taxes.reduce(
            (acc, { cinemacharges }) =>
              acc + +parseFloat(cinemacharges || 0).toFixed(this.MIN_FRACTION_DIGITS),
            0
          )
        ).toFixed(this.MIN_FRACTION_DIGITS);
      }
    },
  },
};
</script>

<style>
.manual_bill_item .multiselect__tags {
  border-radius: unset !important;
  border: unset !important;
}

.manual_bill_input input {
  border: none;
  height: 40px;
  margin: 0;
  width: 100%;
  padding-inline: 10px;
}

.manual_bill_input input::placeholder,
.manual_bill_wrapper .multiselect__placeholder {
  font-size: 12px;
  font-style: italic;
}

.input_text-center input {
  text-align: center;
}

.input_text-right input {
  text-align: right;
}

.manual_bill_wrapper .multiselect__placeholder {
  font-weight: unset !important;
}

.noItemsClass {
  text-align: center;
  width: 100%;
  margin: 16px auto;
  font-size: 16px;
  line-height: 1.2;
  font-weight: 500;
}

.taxPopOver {
  zoom: 0.8;
  min-width: 200px;
}

.errRow {
  border: 2px solid red;
}
.borderNone {
  border: none !important;
}

.complete-tick {
  width: 120px;
  height: 120px;
  display: inline-block;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ManualBillingComponents/ManualBilling.vue